module.exports = __webpack_public_path__ + "img/9.71b22c5d.jpg";